import { ENGLISH, KOREAN, CHINESE, AMERICAN, FRENCH } from "@/constants/language";
import i18n from "@/i18n";

export const isLangEnglish = () => i18n.language === ENGLISH.CODE || i18n.language === AMERICAN.CODE;
export const isLangKorean = () => i18n.language === KOREAN.CODE;
export const isLangChinese = () => i18n.language === CHINESE.CODE;
export const isLangFrench = () => i18n.language === FRENCH.CODE;
